import { render } from "./ManuscriptSelect.vue?vue&type=template&id=13314cae&ts=true"
import script from "./ManuscriptSelect.vue?vue&type=script&lang=ts"
export * from "./ManuscriptSelect.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__